import React from "react";
import { useThemeMode } from "../../../context/contextTheme";
import { useTSContext } from "../../../context/Dashboard/contextTScore";

const CVulnerabilityCard = ({ score }) => {
  const { theme } = useThemeMode();
  const { hasAssets } = useTSContext();

  return (
    <div className="p-2 mb-3">
      <div
        className="card shadow-sm rounded-4 text-center"
        style={{
          width: 260,
          height: 180,
          backgroundColor: theme.labelBgDanger,
          border: `1px solid ${theme.border}`,
        }}
      >
        <div className="card-body d-flex flex-column justify-content-center">
          <div className="mb-2">
            <h4 className="fw-bold" style={{ fontSize: 28, color: theme.labelTextDanger }}>
              Critical
            </h4>
            <h6 style={{ fontSize: 18, color: theme.textMuted }}>
              Vulnerability
            </h6>
          </div>

          <div className="d-flex justify-content-center mt-3">
            {hasAssets ? (
              <h1 className="fw-bold display-6 mb-0" style={{ color: theme.labelTextDanger }}>
                {score}
              </h1>
            ) : (
              <p className="small px-3" style={{ color: theme.textMuted }}>
                Start initial scanning to detect critical vulnerabilities.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CVulnerabilityCard;